import GetMail from './GetMail/GetMail';
import MoveMail from './MoveMail/MoveMail';
import SaveAttachments from './SaveAttachments/SaveAttachments';
import SendMail from './SendMail/SendMail';
import { types } from './types';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @param       showAlert -  show alert
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Actions(action, showAlert, variables, setOpenVariable) {
    if(action.actionName === types.SEND) {
        return <SendMail action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>;
    } else if (action.actionName === types.GET) {
        return <GetMail action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>;
    } else if (action.actionName === types.MOVE) {
        return <MoveMail action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>;
    }else if (action.actionName === types.SAVEATTACHMENTS) {
      return <SaveAttachments action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>;
    }

}
export default Actions;
